import { useContext } from 'react';
import { historyContext } from './context';
export var useHistory = function () {
    var history = useContext(historyContext);
    if (!history)
        throw new Error('useHistory must be used within a HistoryProvider');
    return history;
};
